<template>
  <v-navigation-drawer
    v-model="drawer"
    :mini-variant.sync="miniSidebar"
    color="orange lighten-1"
    :clipped="$vuetify.breakpoint.lgAndUp"
    app
    class="sidebar"
  >
    <v-list class="nav-list" dense>
      <v-list-item link to="/mechanic/rents">
        <v-list-item-action>
          <v-icon>mdi-car-key</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{
            $t('mechanic.rents.title')
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  computed: {
    drawer: {
      get() {
        return this.$store.getters['global/getDrawerSidebar'];
      },
      set(value) {
        this.$store.commit('global/setDrawerSidebar', value);
      },
    },
    miniSidebar: {
      get() {
        return this.$store.getters['global/getMiniSidebar'];
      },
      set(value) {
        this.$store.commit('global/setMiniSidebar', value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.navigation {
  &.mechanic {
    width: 100%;
    background: transparent;

    .mechanic-nav-list {
      display: flex;
      background: transparent;

      @media (max-width: (650px)) {
        display: block;
      }
    }
  }
}
</style>
